import { localStg } from '@/utils/storage';

const emptyInfo: Api.Auth.personInfo = {
  account: '',
  nickname: '',
  gender: '',
  avatar: '',
  dataCenterId: 1,
  email: '',
  isActivate: 0,
  menuIds: [],
  roleId: '',
  roleName: '',
  userId: '',
  tenantId: ''
};

/** 获取登录状态 目前是以缓存中是否存sessionId为判断依据 */
export function getToken() {
  return localStg.get('token') || '';
}

/** 根据缓存判断当前用户是否是超级管理员 */
export function getStaticSuper() {
  const personInfo = localStg.get('personInfo') || emptyInfo;
  if (personInfo.roleId === '1') {
    return true;
  }
  return false;
}

/** 根据缓存返回用户的menuId属性 */
export function getUserMenuId() {
  const personInfo = localStg.get('personInfo') || emptyInfo;
  return personInfo.menuIds;
}

/** 根据缓存返回用户缓存全属性 */
export function getUserInfo() {
  return localStg.get('personInfo') || emptyInfo;
}

/** Clear auth storage */
export function clearAuthStorage() {
  localStg.remove('token');
  localStg.remove('refreshToken');
  localStg.remove('personInfo');
  localStg.remove('userSelectServe');
  localStg.remove('authorizationToken');
  localStg.remove('currentDataCenter');
  localStg.remove('isNoCrossService');
  localStg.remove('dataCenterList');
}



